import QuestionsGenerator from './QuestionsGenerator';


export default QuestionsGenerator;


export SimplifiedGenerator from './SimplifiedGenerator';
